import React from 'react'
import * as StyledComponent from '../styles'
import { isWeChatBrowser } from '../helpers/detectBrowser'
import I18n from '../lib/i18n'
import withHeader from '../lib/withHeader'
import withStore from '../lib/withStore'
import IconWechat from '../images/icon_wechat.svg'

const ThankYou = (props, context) => {
  return <StyledComponent.PageContainer id='scroll-view'>
    <StyledComponent.ThankYou>
      <h3>{I18n.t('containers.thank_you.title')}</h3>
      <div>{ I18n.t('containers.thank_you.message')}</div>
      {
        props.store.session_expired && <div className='bottom-msg'>
          { I18n.t('containers.thank_you.session_expired_message') }
        </div>
      }
      {
        // isWeChatBrowser() && <div className='bottom-msg'>
        //   <div>{ I18n.t('containers.thank_you.wechat_discover_message') }</div>
        //   <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MjM5NzYxMDM2NQ==#wechat_redirect">
        //     <img alt='wechat' src={IconWechat} />
        //   </a>
        // </div>
      }
    </StyledComponent.ThankYou>
  </StyledComponent.PageContainer>
}

export default withStore(withHeader(ThankYou))



// WEBPACK FOOTER //
// ./src/containers/ThankYou.js